import httpApiApplication from '@/app/http/httpApiApplication';

import { type NotificationTemplate } from '../models/Notification';
import { type TaxReturnSummary } from '../models/TaxReturn';

export const taxReturnService = {
  getTaxpayerRecentTaxReturns: async (): Promise<Array<TaxReturnSummary>> => {
    const response = await httpApiApplication.get<Array<TaxReturnSummary>>('/taxreturns/recent');

    return response;
  },
  getTaxReturn: async (id: string): Promise<TaxReturnSummary> => {
    const response = await httpApiApplication.get<TaxReturnSummary>('/taxreturns/' + id);

    return response;
  },
  getTaxReturnHeader: async (): Promise<NotificationTemplate> => {
    const response = await httpApiApplication.get<NotificationTemplate>('/taxreturntemplate/');

    return response;
  }
};
